import RouterSection from '@/Layout/components/RouterSection';
import { checkAuthorization } from '../NavigationGuards';
import * as OrderSessionManager from '@/utils/OrderSessionManager';

export default {
  path: '/survey/lotteryorder',
  name: 'lotteryorder',
  component: RouterSection,
  mode: 'history',
  children: [
    {
      path: 'success',
      name: 'lotteryOrderSuccess',
      component: () => import('@/views/survey/lotteryOrder/Success'),
      beforeEnter: checkAuthorization,
    },
    {
      path: ':step?',
      name: 'lotteryOrderInfo',
      component: () => import('@/views/survey/lotteryOrder'), 
      beforeEnter: checkAuthorization,
      props(route) {
        const sessionId = route.query.sessionId;
        if (sessionId) {
          const session = OrderSessionManager.getSession(sessionId) || {};
          const { step = 'step1' } = route.params;
          const { goodsNoList: goodsInfoList, isClosed } = session;

          return {
            sessionId,
            step,
            goodsInfo: isClosed ? [] : goodsInfoList,
          };
        }

        return {};
      },
    },
  ],
};
